module.exports = __webpack_public_path__ + "img/icon_submenu18.06c84757.svg";